

// Fonction simple pour générer un hash basique
const generateReference = (id, prefix = 'REF') => {
  // Utiliser un seed fixe pour avoir le même hash à chaque fois
  const seed = 5381;
  let hash = seed;
  
  // Convertir l'ID en string et le hasher
  const str = id.toString();
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i);
  }
  
  // Convertir en base36 pour avoir une string courte
  const hashed = Math.abs(hash).toString(36).toUpperCase();
  
  // Retourner avec préfixe et 6 caractères
  return `${prefix}${hashed.substring(0, 6)}`;
};

// Fonction pour retrouver l'ID depuis la référence (si nécessaire)
const getOriginalIdFromReference = (ref, orders) => {
  return orders.find(order => generateReference(order.id) === ref)?.id;
};

export { generateReference, getOriginalIdFromReference };